<template>
    <div class="keyfeatures-content-flex flex xl:flex-row lg:flex-col md:flex-col items-start">
        <div class="left flex-none w-full xl:max-w-505px lg:max-w-none max-w-505px md:max-w-none">
            <div class="keyfeatures-left-box">
                <div class="keyfeatures-left-content">
                    <!-- slick nav -->
                    <ul class="keyfeatures-slide-nav text-white text-center mb-spc39 xl:flex lg:flex flex md:hidden">
                        <li class="nav-item">
                            <a
                                href="#admin-panel"
                                @click.prevent="setActive('admin-panel')"
                                :class="{ active: isActive('admin-panel') }"
                                class="keyfeatures-slide-link nav-link block px-spc38 cursor-pointer text-size2 leading-6 opacity-50 pb-spc36">
                                Admin Panel
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href="#customer-app"
                                @click.prevent="setActive('customer-app')"
                                :class="{ active: isActive('customer-app') }"
                                class="keyfeatures-slide-link nav-link block px-spc38 cursor-pointer text-size2 leading-6 opacity-50 pb-spc36">
                                Customer App
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href="#driver-app"
                                @click.prevent="setActive('driver-app')"
                                :class="{ active: isActive('driver-app') }"
                                class="keyfeatures-slide-link nav-link block px-spc38 cursor-pointer text-size2 leading-6 opacity-50 pb-spc36">
                                Driver App
                            </a>
                        </li>
                    </ul>
                    <ul class="keyfeatures-slide-nav keyfeatures-slide-nav-mobile text-white text-center mb-spc39 xl:hidden lg:hidden hidden md:block">
                        <slick :options="slickOptions">
                            <li class="nav-item">
                                <a
                                    href="#admin-panel2"
                                    @click.prevent="setActive2('admin-panel2')"
                                    :class="isActive2('admin-panel2')"
                                    class="keyfeatures-slide-link nav-link block px-spc38 cursor-pointer text-size2 leading-6 opacity-50 pb-spc36">
                                    Admin Panel
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    href="#customer-app2"
                                    @click.prevent="setActive2('customer-app2')"
                                    :class="isActive2('customer-app2')"
                                    class="keyfeatures-slide-link nav-link block px-spc38 cursor-pointer text-size2 leading-6 opacity-50 pb-spc36">
                                    Customer App
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    href="#driver-app2"
                                    @click.prevent="setActive2('driver-app2')"
                                    :class="isActive2('driver-app2')"
                                    class="keyfeatures-slide-link nav-link block px-spc38 cursor-pointer text-size2 leading-6 opacity-50 pb-spc36">
                                    Driver App
                                </a>
                            </li>
                        </slick>
                    </ul>

                    <SectionHeading
                            title="Key Features of our On Demand Management System"
                            content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero."
                    />
                </div>
            </div>
        </div>
        <div class="right  pt-spc36 flex-1 xl:pl-spc40 lg:pl-spc40 pl-spc40 md:pl-0 xl:mt-0 lg:mt-0 md:mt-spc65">
            <div class="keyfeatures-content-desktop-slider">
                <div class="keyfeatureSlideDesktop w-full xl:block lg:block block md:hidden">
                    <div id="admin-panel" class="hidden" :class="{ 'active': isActive('admin-panel') }">
                        <KeyfeatureSlider :keyfeaturesDesktop="keyfeaturesDesktopData" />
                    </div>
                    <div id="customer-app" class="hidden" :class="{ 'active': isActive('customer-app') }">
                        <KeyfeatureSlider :keyfeaturesDesktop="keyfeaturesDesktopData2" />
                    </div>
                    <div id="driver-app" class="hidden" :class="{ 'active': isActive('driver-app') }">
                        <KeyfeatureSlider :keyfeaturesDesktop="keyfeaturesDesktopData3" />
                    </div>
                </div>
                <div class="keyfeatureSlideDesktop keyfeatureSlideMobile w-full xl:hidden lg:hidden hidden md:block" id="slick-slide">
                    <div id="admin-panel2" class="hidden" :class="{ 'active': isActive2('admin-panel2') }">
                        <KeyfeatureSliderMobile :keyfeaturesMobile="keyfeaturesDesktopData" />
                    </div>
                    <div id="customer-app2" class="hidden" :class="{ 'active': isActive2('customer-app2') }">
                        <KeyfeatureSliderMobile :keyfeaturesMobile="keyfeaturesDesktopData2" />
                    </div>
                    <div id="driver-app2" class="hidden" :class="{ 'active': isActive2('driver-app2') }">
                        <KeyfeatureSliderMobile :keyfeaturesMobile="keyfeaturesDesktopData3" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import KeyfeatureSliderMobile from "../../../sliders/KeyfeatureSliderMobile";
    import KeyfeatureSlider from "../../../sliders/KeyfeatureSlider";
    import SectionHeading from "../../../common/SectionHeading";
    // import $ from 'jquery';
    // Slick Slider
    import Slick from 'vue-slick'
    import 'slick-carousel/slick/slick.css'


    let keyfeaturesDesktopData = {
        keyfeatureDesktopList: [
            {
                img: require('@/assets/images/feature-1.png'),
                title: "Fleet Management",
                content: "Allows the admin to communicate with the drivers and track the vehicles at any time accessed from any place."
            },
            {
                img: require('@/assets/images/feature-2.png'),
                title: "Logistics",
                content: "Enables the owners to allocate tasks, schedule the deliveries & dispatch the orders according to the availability."
            },
            {
                img: require('@/assets/images/feature-3.png'),
                title: "Route Map Planning",
                content: "Optimize the best route to ensure the on-time dispatch of the orders to the destinations."
            },
            {
                img: require('@/assets/images/feature-4.png'),
                title: "Subscription",
                content: "An amazing feature for your consumers that order recurring on a daily or weekly, monthly basis."
            },
            {
                img: require('@/assets/images/feature-5.png'),
                title: "Workforce Management",
                content: "Examine data and records to enhance the execution of dispatching orders with limited resources to boost profits."
            },
            {
                img: require('@/assets/images/feature-6.png'),
                title: "Workforce Management",
                content: "To check and enhance the efficiency, a kind of notification is sent whenever a dispatcher vehicle passes through geofence."
            },
        ]
    }
    let keyfeaturesDesktopData2 = {
        keyfeatureDesktopList: [
            {
                img: require('@/assets/images/feature-1.png'),
                title: "Admin Management",
                content: "Allows the admin to communicate with the drivers and track the vehicles at any time accessed from any place."
            },
            {
                img: require('@/assets/images/feature-2.png'),
                title: "Fleet Management",
                content: "Enables the owners to allocate tasks, schedule the deliveries & dispatch the orders according to the availability."
            },
            {
                img: require('@/assets/images/feature-3.png'),
                title: "Route Map Planning",
                content: "Optimize the best route to ensure the on-time dispatch of the orders to the destinations."
            },
            {
                img: require('@/assets/images/feature-4.png'),
                title: "Subscription",
                content: "An amazing feature for your consumers that order recurring on a daily or weekly, monthly basis."
            },
            {
                img: require('@/assets/images/feature-5.png'),
                title: "Workforce Management",
                content: "Examine data and records to enhance the execution of dispatching orders with limited resources to boost profits."
            },
            {
                img: require('@/assets/images/feature-6.png'),
                title: "Workforce Management",
                content: "To check and enhance the efficiency, a kind of notification is sent whenever a dispatcher vehicle passes through geofence."
            },
        ]
    }
    let keyfeaturesDesktopData3 = {
        keyfeatureDesktopList: [
            {
                img: require('@/assets/images/feature-1.png'),
                title: "Seo Management",
                content: "Allows the admin to communicate with the drivers and track the vehicles at any time accessed from any place."
            },
            {
                img: require('@/assets/images/feature-2.png'),
                title: "Fleet Management",
                content: "Enables the owners to allocate tasks, schedule the deliveries & dispatch the orders according to the availability."
            },
            {
                img: require('@/assets/images/feature-3.png'),
                title: "Route Map Planning",
                content: "Optimize the best route to ensure the on-time dispatch of the orders to the destinations."
            },
            {
                img: require('@/assets/images/feature-4.png'),
                title: "Subscription",
                content: "An amazing feature for your consumers that order recurring on a daily or weekly, monthly basis."
            },
            {
                img: require('@/assets/images/feature-5.png'),
                title: "Workforce Management",
                content: "Examine data and records to enhance the execution of dispatching orders with limited resources to boost profits."
            },
            {
                img: require('@/assets/images/feature-6.png'),
                title: "Workforce Management",
                content: "To check and enhance the efficiency, a kind of notification is sent whenever a dispatcher vehicle passes through geofence."
            },
        ]
    }

    export default {
        name: "KeyFeatures",
        components: {
            SectionHeading,
            KeyfeatureSlider,
            KeyfeatureSliderMobile,
            Slick
        },
        data() {
            return {
                activeItem: 'admin-panel',
                activeItem2: 'admin-panel2',
                keyfeaturesDesktopData2,
                keyfeaturesDesktopData3,
                keyfeaturesDesktopData,
            }
        },
        methods: {
            isActive (menuItem) {
                return this.activeItem === menuItem
            },
            setActive (menuItem) {
                this.activeItem = menuItem
            },
            isActive2 (menuItem) {
                return this.activeItem2 === menuItem
            },
            setActive2 (menuItems) {
                this.activeItem2 = menuItems
            }
        },
        computed: {
            slickOptions() {
                return {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    centerPadding: '30px',
                    infinite: false,
                    focusOnSelect: true,
                    variableWidth: true,
                }
            },
        }
    }
</script>

<style scoped>

</style>